<template>
    <div class="comJSONData chartConfig_viewDP scrollBar_xy">
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">数据类型</span>
            <el-select v-model="config.type" placeholder="请选择数据类型"
                       :popper-append-to-body="false">
                <el-option label="API接口" :value="0"></el-option>
                <el-option label="静态数据" :value="1"></el-option>
            </el-select>
        </div>
        <div v-if="config.type===0">
            <div class="chartDivConfig textViewConfig">
                <span class="span_til">URL地址</span>
                <el-input v-model="config.apiData.url"
                          type="textarea" autosize></el-input>
            </div>
            <div class="chartDivConfig selViewConfig noMargin">
                <span class="span_til">接口类型</span>
                <el-select v-model="config.apiData.type" placeholder="请选择接口类型"
                           :popper-append-to-body="false">
                    <el-option label="GET" value="get"></el-option>
                    <el-option label="POST" value="post"></el-option>
                </el-select>
            </div>
            <div class="chartDivConfig selViewConfig noMargin" v-if="config.apiData.type==='post'">
                <span class="span_til">参数类型</span>
                <el-select v-model="config.apiData.postType" placeholder="请选择接口类型"
                           :popper-append-to-body="false">
                    <el-option label="PARAMS" :value="0"></el-option>
                    <el-option label="JSON" :value="1"></el-option>
                </el-select>
            </div>
            <div class="chartDivConfig textViewConfig noMargin"
                 v-if="config.apiData.type==='post'&&config.apiData.postType===0">
                <span class="span_til" style="width: 100%;">POST参数</span>
                <el-input v-model="post"
                          type="textarea" autosize></el-input>
            </div>
            <div class="chartDivConfig textViewConfig  editorJSON "
                 v-if="config.apiData.type==='post'&&config.apiData.postType===1">
                <span class="span_til" style="width: 100%;">POST参数</span>
                <editor ref="post" :options="{wrap:'free'}" v-model="post" @init="editorInit"
                        lang="json" theme="twilight" width="100%" placeholder="请输入JSON格式"
                        height="100"></editor>
                <div class="comJSONData_div_btn">
                    <div @click="getPOSTClick(0)">清空</div>
                    <div @click="getPOSTClick(2)">格式化</div>
                </div>
            </div>
            <div class="chartDivConfig checkViewConfig noMargin">
                <el-checkbox v-model="config.apiData.headerShow">是否启用HEADER</el-checkbox>
            </div>
            <div class="chartDivConfig textViewConfig editorJSON" v-show="config.apiData.headerShow">
                <span class="span_til">HEADER</span>
                <editor ref="header" :options="{wrap:'free'}" v-model="header" @init="editorInit"
                        lang="json" theme="twilight" width="100%" placeholder="请输入JSON格式"
                        height="100"></editor>
                <div class="comJSONData_div_btn">
                    <div @click="getHEDERClick(0)">清空</div>
                    <div @click="getHEDERClick(2)">格式化</div>
                </div>
            </div>
            <div class="comJSONData_save">
                <div @click="getInterfaceData">获取接口数据</div>
            </div>
        </div>
        <div class="comJSONData_div editorJSON">
            <editor ref="editor" :options="{wrap:'free'}" v-model="config.valData" @init="editorInit"
                    lang="json" theme="twilight" width="100%"
                    height="300"></editor>
            <div class="comJSONData_div_btn">
                <div @click="getJSONClick(0)">清空</div>
                <div @click="getJSONClick(1)">默认</div>
                <div @click="getJSONClick(2)">格式化</div>
            </div>
        </div>
        <component :is="nowChart.comPonent.jsonComponent" class="comJSONData_component"></component>
        <div class="comJSONData_save">
            <div @click="getRender">生成数据</div>
        </div>
        <FDialog class="comJSONData_dialog textViewConfig" :dialog="dialog.show" title="默认数据"
                 @close="getJSONDataDialog(1)"
                 moveWidth="570px">
            <div class="JSONData_dialog_count">
                <div class="editorJSON">
                    <editor ref="dialogEditor" :options="{wrap:'free'}" v-model="dialog.json" @init="editorInit"
                            lang="json" theme="twilight" width="100%" readonly
                            height="500"></editor>
                    <div class="comJSONData_div_btn">
                        <div @click="getdialogJSONClick(0)">还原</div>
                        <div @click="getdialogJSONClick(1)">格式化</div>
                    </div>
                </div>
                <div class="div_btn">
                    <FBtn type="2" @click="getdialogJSONClick(2)">填充默认JSON</FBtn>
                </div>
            </div>
        </FDialog>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/9 3:01 下午
     */


    import {getParamAPI} from '@/assets/axios/commAxios.js'

    export default {
        name: 'comJSONData',
        components: {
            editor: require('vue2-ace-editor')
        },
        data() {
            return {
                count: '',
                post: '',
                header: '',
                dialog: {
                    show: false,
                    json: ''
                },
            }
        },
        computed: {
            config() {
                if (this.$store.state.designer.updParam.JSONData.apiData.post) {
                    try {
                        let post = JSON.stringify(JSON.parse(this.$store.state.designer.updParam.JSONData.apiData.post), null, '  ');
                        this.post = post;
                    } catch (e) {
                        this.post = this.$store.state.designer.updParam.JSONData.apiData.post;
                    }
                }
                if (this.$store.state.designer.updParam.JSONData.apiData.header) {
                    try {
                        let header = JSON.stringify(JSON.parse(this.$store.state.designer.updParam.JSONData.apiData.header), null, '  ');
                        this.header = header;
                    } catch (e) {
                        this.header = this.$store.state.designer.updParam.JSONData.apiData.header;
                    }
                }
                return this.$store.state.designer.updParam.JSONData;
            },
            nowChart() {
                return this.$store.state.designer.nowChart;
            },
        },
        methods: {
            editorInit() {
                require('brace/ext/language_tools');
                require('brace/mode/json');
                require('brace/theme/twilight');
                require('brace/mode/yaml');
                require('brace/mode/less');
                require('brace/mode/javascript');
            },
            //JSON
            getJSONClick(type) {
                if (type === 0) {
                    this.config.valData = '';
                } else if (type === 1) {
                    // this.config.valData = this.config.oldValData;
                    this.dialog.json = this.config.oldValData;
                    this.getJSONDataDialog(0)
                } else if (type === 2) {
                    try {
                        let data = JSON.parse(this.config.valData);
                        this.config.valData = JSON.stringify(data, null, '  ')
                    } catch (e) {
                        this.getMsg('格式化失败', 'info');
                    }
                }
            },
            //header
            getHEDERClick(type) {
                if (type === 0) {
                    this.header = '';
                } else if (type === 2) {
                    try {
                        let data = JSON.parse(this.header);
                        this.header = JSON.stringify(data, null, '  ')
                    } catch (e) {
                        this.getMsg('格式化失败', 'info');
                    }
                }
            },
            //post
            getPOSTClick(type) {
                if (type === 0) {
                    this.post = '';
                } else if (type === 2) {
                    try {
                        let data = JSON.parse(this.post);
                        this.post = JSON.stringify(data, null, '  ')
                    } catch (e) {
                        this.getMsg('格式化失败', 'info');
                    }
                }
            },
            //渲染
            async getRender() {
                this.config.apiData.post = this.post;
                this.config.apiData.header = this.header;
                this.nowChart.comParam.JSONData = JSON.parse(JSON.stringify(this.config));
                await this.$store.dispatch('screenDataRender');
            },
            //获取接口信息
            getInterfaceData() {
                this.config.apiData.post = this.post;
                this.config.apiData.header = this.header;
                this.nowChart.comParam.JSONData.apiData = JSON.parse(JSON.stringify(this.config.apiData));

                if (!this.config.apiData.url) {
                    this.getMsg('请填写接口URL');
                    return;
                }
                try {
                    if (this.config.apiData.type === 'post') {
                        if (this.post) {
                            if (this.config.apiData.postType === 1) {
                                let post = JSON.parse(this.post);
                                this.config.apiData.post = this.post;
                            } else {
                                this.config.apiData.post = this.post;
                            }
                        } else {
                            this.config.apiData.post = '';
                        }
                    }
                } catch (e) {
                    this.getMsg('请填写正确格式的POST参数');
                    this.config.apiData.post = '';
                    return;
                }
                try {
                    if (this.config.apiData.headerShow) {
                        if (this.header) {
                            let header = JSON.parse(this.header);
                            this.config.apiData.header = this.header;
                        } else {
                            this.config.apiData.header = '';
                        }
                    }
                } catch (e) {
                    this.getMsg('请填写正确格式的HEADER参数');
                    this.config.apiData.header = '';
                    return;
                }
                //
                getParamAPI(this.config.apiData).then(res => {
                    try {
                        let data = JSON.parse(JSON.stringify(res));
                        this.config.valData = JSON.stringify(data, null, '  ');
                    } catch (e) {
                        this.getMsg('接口不符合JSON结构/接口出现错误')
                    }
                }).catch(() => {
                    this.getMsg('接口不符合JSON结构/接口出现错误')
                })
            },
            //默认弹框
            getJSONDataDialog(type) {
                if (type === 0) {
                    this.dialog.show = true;
                    // this.$nextTick(()=>{
                    //     this.$refs.dialogEditor.editor.setReadOnly(true);
                    // })
                } else if (type === 1) {
                    this.dialog.show = false;
                }
            },
            //弹框JSON
            getdialogJSONClick(type) {
                if (type === 0) {
                    this.dialog.json = this.config.oldValData;
                } else if (type === 1) {
                    try {
                      let data = JSON.parse(this.dialog.json);
                        this.dialog.json = JSON.stringify(data, null, '  ')
                    } catch (e) {
                        this.getMsg('格式化失败', 'info');
                    }
                } else if (type === 2) {
                    this.config.valData = this.dialog.json;
                    this.getJSONDataDialog(1);
                }
            }
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    //普通字体
    @JSON_color: #E2E2E2;
    @JSON_borderColor: #483b3b;
    @JSON_th_backColor: #232323;

    //presentation
    .comJSONData {
        .comJSONData_div {
            margin-top: 5px;

            .comJSONData_div_btn {
                width: 100%;
                height: 30px;

                > div {
                    width: calc(100% / 3);
                    float: left;
                    height: 100%;
                    color: @JSON_color;
                    border: 1px solid @JSON_borderColor;
                    background-color: @JSON_th_backColor;
                    display: inline-block;
                    text-align: center;
                    cursor: pointer;
                    letter-spacing: 1px;
                    font-size: 12px;
                    line-height: 28px;
                    border-top: 0;
                    .noSelect;
                }

                > div:hover {
                    background-color: hsl(@JSON_th_backColor, 40%);
                    color: @JSON_color;
                }
            }

            .comJSONData_div_save {
                width: 100%;
                height: 30px;

                > div {
                    width: 100%;
                    float: left;
                    height: 100%;
                    color: @JSON_color;
                    border: 1px solid @JSON_borderColor;
                    background-color: @JSON_th_backColor;
                    display: inline-block;
                    text-align: center;
                    cursor: pointer;
                    letter-spacing: 1px;
                    font-size: 12px;
                    line-height: 28px;
                    border-top: 0;
                    .noSelect;
                }

                > div:hover {
                    background-color: hsl(@JSON_th_backColor, 40%);
                    color: @JSON_color;
                }
            }
        }

        .comJSONData_component {
            padding: 0 !important;
            margin-top: 10px;
            padding-left: 5px !important;
        }

        .comJSONData_save {
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;

            > div {
                width: 100%;
                height: 30px;
                border-radius: 3px;
                background-color: rgba(0, 39, 116, 0.8);
                text-align: center;
                line-height: 30px;
                color: @JSON_color;
                font-size: 14px;
                letter-spacing: 2px;
                cursor: pointer;
                .noSelect;

            }

            > div:hover {
                background-color: rgba(0, 39, 116, 1);

            }
        }
    }

    .textViewConfig {
        .comJSONData_div_btn {
            width: 100%;
            height: 30px;

            > div {
                width: calc(100% / 2);
                float: left;
                height: 100%;
                color: @JSON_color;
                border: 1px solid @JSON_borderColor;
                background-color: @JSON_th_backColor;
                display: inline-block;
                text-align: center;
                cursor: pointer;
                letter-spacing: 1px;
                font-size: 12px;
                line-height: 28px;
                border-top: 0;
                .noSelect;
            }

            > div:hover {
                background-color: hsl(@JSON_th_backColor, 40%);
                color: @JSON_color;
            }
        }
    }

    .editorJSON {
        .ace-twilight {
            border: 2px solid @JSON_borderColor;
        }

        .ace_layer {
        }
    }

    .comJSONData_dialog {
        .el-dialog__body {
            background-color: #333;

            .div_btn {
                width: 100%;
                margin-top: 15px;

                .FBtn {
                    float: right;
                }
            }
        }
    }
</style>